<template>
  <el-dialog
    :visible.sync="isShowDialog" class="dialog-square"
    :title="$t('feedback.feedback')" center width="520px" @close="whenDialogClose">
    <!-- :close-on-click-modal="false" -->
    <div class="dialog-con df-l-c-fs w100p">
      <div class="dialog-ctr w100p">
        <div class="mydialog df-l-c-fs">

          <div class="text f-s _redcolor w100p" v-for="(x,i) in deviceErrorMessages" :key="i">{{$t('index.errorReason')}}：{{x['message'+_lang]}}</div>
          <div class="btns df-w-c-sb">
            <div class="whitebtn btn" :class="{'btn-l':lang==='en'}" @click="submitDelayTime(1)">{{$t('index.remindMe10')}}</div>
            <div class="whitebtn btn" :class="{'btn-l':lang==='en'}" @click="submitDelayTime(2)">{{$t('index.remindMe30')}}</div>
            <div class="whitebtn btn" :class="{'btn-l':lang==='en'}" @click="submitDelayTime(3)">{{$t('index.remindMe60')}}</div>
            <div class="whitebtn btn" :class="{'btn-l':lang==='en'}" @click="submitDelayTime(4)">{{$t('index.remindMe180')}}</div>
            <div class="df-c-ct w100p">
              <div class="whitebtn btn" :class="{'btn-l':lang==='en'}" @click="submitDelayTime(5)">{{$t('index.remindMe24')}}</div>
            </div>
          </div>

        </div>
      </div>
      <!-- <div class="dialog-btm w100p df-c-sa">
        <div class="themebtn" @click="submit">{{$t('common.comfirm')}}</div>
      </div> -->
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: 'DialogDriveError',
  data() {
    return {
      isShowDialog: false,

      deviceStatusOk: false,
      deviceStatusTimeOver: false,
      deviceErrorMessages: [],

      // isGreenLight: true,
      // isShowTip: false,
    }
  },
  watch: {
    networkStatus_x(val) {
      // console.log(`%cval:`, 'color: #f00;', val)
      this.deviceStatusOk = val
      if (val) {
        const INDEX = this.deviceErrorMessages.length - 1
        if (this.deviceErrorMessages[INDEX].mark) {
          this.deviceErrorMessages.splice(INDEX, 1)
        }
      } else {
        this.deviceErrorMessages.push({
          mark: true,
          message_zh: this.$t('index.thisOne') + '離線',
          message_en: this.$t('index.thisOne') + ' Disconnected'
        })
      }
    }
  },
  methods: {
    open(list) {
      this.scan_canLeave_x_save(false)
      this.isShowDialog = true
    },
    close() {
      this.isShowDialog = false
    },
    whenDialogClose() {
      this.scan_canLeave_x_save(true)
      this.isShowDialog = false
    },

    // 提交
    submitDelayTime(n) {
      let delaytime = new Date().getTime()
      switch (n) {
        case 1: delaytime += 10 * 60 * 1000; break
        case 2: delaytime += 30 * 60 * 1000; break
        case 3: delaytime += 60 * 60 * 1000; break
        case 4: delaytime += 3 * 60 * 60 * 1000; break
        case 5:
          let temp = delaytime + 24 * 60 * 60 * 1000
          let temp2 = new Date(temp)
          let temp3 = temp2.getFullYear() + '/' + (temp2.getMonth()+1) + '/' + temp2.getDate()
          delaytime = new Date(temp3).getTime()
          break
      }
      localStorage.setItem('dola_delaytime', delaytime)
      this.close()
      this.deviceStatusTimeOver = false
      this.submit()
    },

    submit() {
      this.$emit('getStatus', {
        isGreenLight: this.deviceStatusOk && this.networkStatus_x,
        isShowTip: !this.deviceStatusOk && this.deviceStatusTimeOver,
      })
    },


    // 设备状态查询
    deviceStatusSearch(autoOnlyBendRead = false) {
      if (this.currentShopId) {
        const rD = {
          id: this.currentShopId,
          type: 1,
          autoOnlyBendRead,
        }
        this.$api.device_status_search(rD).then(res => {
          if (res.status == 0) {
            // let _R = res.data
            let _R = res.data.filter(x1 => x1.type === 1)
            // console.log(`%c设备状态:`, 'color: #00f;', _R)
            this.deviceStatusOk = !_R.length
            if (_R.length) {
              // type 设备类型，1是打印机，2是触摸
              // uuid 设备类型的UUID,如果是打印机，那么是打印机的ID,如果是触摸屏，那么是UUID
              // name 设备名称，打印是打印机的名称，触摸屏是UUID
              // reason 1是打印机离线，2是打印机纸张不够了，3是触摸屏离线
              this.deviceErrorMessages = _R.map(x => {
                let message_zh = '', message_en = ''
                switch (x.type) {
                  case 1:
                    message_zh += x.name
                    message_en += x.name + ' '
                    break
                  case 2:
                    message_zh += '觸摸屏'
                    message_en += 'Touch Screen '
                    break
                }
                message_zh += ['','離線','紙張不夠','離線'][x.reason]
                message_en += ['','Disconnected','Paper Run Out','Disconnected'][x.reason]
                return {
                  message_zh,
                  message_en,
                }
              })
              // console.log(`%c处理后的设备状态:`, 'color: #f0f;', this.deviceErrorMessages)
              let dola_delaytime = localStorage.getItem('dola_delaytime')
              this.deviceStatusTimeOver = new Date() > dola_delaytime
            } else {
              this.deviceStatusTimeOver = true
            }
            
            this.submit()

          } else { this._status(res) }
        })
      }
    },
  },
  created() {
    // this.setTimer()
    if (this.currentShopId) {
      this.deviceStatusSearch()
    }
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/css/util_dialog.scss';
.mydialog{
  padding: 20px 60px 0;
  .text{min-height: 28px;line-height: 28px;padding: 6px 0;}
  .btns{padding: 0 20px;}
  .btn{margin: 20px 0;width: 160px;}
  .btn-l{margin: 10px 0;width: 360px;}
}
</style>